export function buildCell(y, m, d) {
  return {
    day: d,
    dateStr: `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`,
    isCurrentMonth: true,
  };
}

export function getMonthGrid(year, month, fillAdjacent = true) {
  const firstDow = new Date(Date.UTC(year, month, 1)).getUTCDay();
  const lastDay = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const cells = [];

  // 전달 채우기
  if (firstDow > 0) {
    if (fillAdjacent) {
      const py = month === 0 ? year - 1 : year;
      const pm = month === 0 ? 11 : month - 1;
      const pLast = new Date(Date.UTC(py, pm + 1, 0)).getUTCDate();
      for (let i = firstDow - 1; i >= 0; i--) {
        const d = pLast - i;
        cells.push({ day: d, dateStr: `${py}-${String(pm + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`, isCurrentMonth: false });
      }
    } else {
      for (let i = 0; i < firstDow; i++) cells.push(null);
    }
  }

  // 이번달
  for (let d = 1; d <= lastDay; d++) {
    cells.push({ day: d, dateStr: `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`, isCurrentMonth: true });
  }

  // 다음달 채우기
  const rem = cells.length % 7;
  if (rem > 0) {
    if (fillAdjacent) {
      const ny = month === 11 ? year + 1 : year;
      const nm = month === 11 ? 0 : month + 1;
      for (let d = 1; d <= 7 - rem; d++) {
        cells.push({ day: d, dateStr: `${ny}-${String(nm + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`, isCurrentMonth: false });
      }
    } else {
      for (let i = 0; i < 7 - rem; i++) cells.push(null);
    }
  }

  return cells;
}

// 연속 캘린더용 — fromMonth 1일~toMonth 말일을 포함한 완전한 주 목록 반환
// 각 cell: { day, month, year, dateStr, inRange, isNewMonth, dow }
export function buildContinuousWeeks(fromYear, fromMonth, toYear, toMonth) {
  const rangeStart = new Date(Date.UTC(fromYear, fromMonth, 1));
  const rangeEnd = new Date(Date.UTC(toYear, toMonth + 1, 0));

  // 첫 일요일 ~ 마지막 토요일로 확장
  const gridStart = new Date(rangeStart);
  gridStart.setUTCDate(gridStart.getUTCDate() - gridStart.getUTCDay());
  const gridEnd = new Date(rangeEnd);
  gridEnd.setUTCDate(gridEnd.getUTCDate() + (6 - gridEnd.getUTCDay()));

  const cells = [];
  for (let d = new Date(gridStart); d <= gridEnd; d.setUTCDate(d.getUTCDate() + 1)) {
    const y = d.getUTCFullYear(), m = d.getUTCMonth(), day = d.getUTCDate();
    cells.push({
      day, month: m, year: y,
      dateStr: `${y}-${String(m + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      inRange: d >= rangeStart && d <= rangeEnd,
      isNewMonth: day === 1,
      dow: d.getUTCDay(),
    });
  }

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

export function getWeekBars(weekCells, schedules, itemKey = 'item') {
  const valid = weekCells.filter(Boolean);
  if (!valid.length) return [];
  const weekStart = valid[0].dateStr;
  const weekEnd = valid[valid.length - 1].dateStr;

  const bars = [];
  for (const s of schedules) {
    const sd = s.startDate, ed = s.endDate;
    if (ed < weekStart || sd > weekEnd) continue;
    const clampedStart = sd < weekStart ? weekStart : sd;
    const clampedEnd = ed > weekEnd ? weekEnd : ed;
    const startCol = weekCells.findIndex(c => c?.dateStr === clampedStart);
    let endCol = -1;
    for (let i = weekCells.length - 1; i >= 0; i--) {
      if (weekCells[i]?.dateStr === clampedEnd) { endCol = i; break; }
    }
    if (startCol === -1 || endCol === -1) continue;
    bars.push({
      [itemKey]: s,
      startCol,
      span: endCol - startCol + 1,
      isStart: sd === clampedStart,
      isEnd: ed === clampedEnd,
    });
  }

  bars.sort((a, b) => a.startCol - b.startCol || b.span - a.span);
  const rowEnds = [];
  for (const bar of bars) {
    let row = 0;
    while (rowEnds[row] !== undefined && rowEnds[row] >= bar.startCol) row++;
    bar.row = row;
    rowEnds[row] = bar.startCol + bar.span - 1;
  }
  return bars;
}
